import axios from 'axios';

const API_URL = 'https://uocoursesb.onrender.com/';

// In-memory cache for instant responses
const requestCache = new Map();
const CACHE_EXPIRY = 5 * 60 * 1000; // 5 minutes

// Keep-alive: Wake up the server proactively
let isServerAwake = false;
let wakeUpInProgress = false;

const wakeUpServer = async () => {
  if (isServerAwake || wakeUpInProgress) return;
  
  wakeUpInProgress = true;
  console.log('Waking up server...');
  
  try {
    await axios.get(`${API_URL}/health`, { timeout: 30000 });
    isServerAwake = true;
    console.log('Server is awake!');
  } catch (error) {
    console.warn('Server wake-up failed:', error.message);
  } finally {
    wakeUpInProgress = false;
  }
};

// Call this when the app loads
export const initializeApp = () => {
  wakeUpServer();
  
  // Keep pinging every 5 minutes to prevent sleep
  setInterval(() => {
    if (isServerAwake) {
      axios.get(`${API_URL}/health`, { timeout: 5000 })
        .catch(() => {
          isServerAwake = false;
          wakeUpServer();
        });
    }
  }, 5 * 60 * 1000);
};

export const getCourseRecommendations = async (userInput) => {
  // Wake up server if not awake
  if (!isServerAwake && !wakeUpInProgress) {
    wakeUpServer();
  }
  
  // Check cache first
  const cacheKey = userInput.toLowerCase().trim();
  const cached = requestCache.get(cacheKey);
  
  if (cached && Date.now() - cached.timestamp < CACHE_EXPIRY) {
    console.log('Returning cached result');
    return { response: cached.data };
  }

  try {
    const response = await axios.post(`${API_URL}/chat`, 
      { input: userInput },
      { timeout: 45000 } // Increased timeout for cold starts
    );

    // Mark server as awake after successful request
    isServerAwake = true;

    // Cache the successful response
    if (response.data && response.data.response) {
      requestCache.set(cacheKey, {
        data: response.data.response,
        timestamp: Date.now()
      });

      // Limit cache size to prevent memory issues
      if (requestCache.size > 50) {
        const firstKey = requestCache.keys().next().value;
        requestCache.delete(firstKey);
      }
    }

    return response.data;
    
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      isServerAwake = false;
      throw new Error('Server is waking up, please try again in a moment...');
    }
    console.error("API Request Error:", error.response || error.message);
    throw error;
  }
};